var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 195,
    viewBox: "0 0 188 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6651 25.2294L94 3.20667L152.335 25.2294L183.438 81.1066L172.628 144.691L125.027 186.12H62.9728L15.3716 144.691L4.56244 81.1066L35.6651 25.2294Z",
    stroke: "#E66100",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5 63.3L97.4 113.3H89.8L88.7 63.3H98.5ZM94 133.6C92.2667 133.6 90.8 133 89.6 131.8C88.4 130.6 87.8 129.133 87.8 127.4C87.8 125.667 88.4 124.2 89.6 123C90.8 121.8 92.2667 121.2 94 121.2C95.6667 121.2 97.0667 121.8 98.2 123C99.4 124.2 100 125.667 100 127.4C100 129.133 99.4 130.6 98.2 131.8C97.0667 133 95.6667 133.6 94 133.6Z",
    fill: "#E66100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.fa44785789bb3451860063122d914005.svg";
export { ForwardRef as ReactComponent };